import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "mx-auto my-2 p-3",
  style: {"max-width":"20rem"}
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  for: "username",
  class: "mb-2"
}
const _hoisted_4 = {
  for: "password",
  class: "mb-2 mt-3"
}
const _hoisted_5 = {
  class: "c-button mt-3",
  type: "submit"
}
const _hoisted_6 = {
  key: 0,
  class: "fixed-top p-2 text-center bg-danger text-white"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers((...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
      class: "d-flex flex-column"
    }, [
      _createElementVNode("div", {
        class: "login-logo my-5 d-flex justify-content-center",
        innerHTML: _ctx.logo
      }, null, 8 /* PROPS */, _hoisted_2),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("username")), 1 /* TEXT */),
      _cache[1] || (_cache[1] = _createElementVNode("input", {
        name: "username",
        class: "c-input",
        id: "username",
        autocomplete: "off",
        required: "",
        autofocus: ""
      }, null, -1 /* CACHED */)),
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("password")), 1 /* TEXT */),
      _cache[2] || (_cache[2] = _createElementVNode("input", {
        name: "password",
        class: "c-input",
        id: "password",
        type: "password",
        required: ""
      }, null, -1 /* CACHED */)),
      _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t("login")), 1 /* TEXT */),
      (_ctx.hasError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("login_error")), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 32 /* NEED_HYDRATION */)
  ]))
}